// extracted by mini-css-extract-plugin
export default {"iphone":"IPhone_iphone__Ap1zI","land":"IPhone_land__Dhln2","screen":"IPhone_screen__bCEm8","island":"IPhone_island__GypRr","sheen":"IPhone_sheen__qO5Wm","big":"IPhone_big__dzIFi"};